import * as React from 'react'

import * as Constants from './constants'

export function Callback() {
  React.useEffect(() => {
    window.top.postMessage({ type: Constants.IFRAME_CALLBACK_EVENT }, '*')
  }, [])

  return null
}
